import React from 'react';

const Layer1 = () => {
  return (
    <svg
      preserveAspectRatio='xMinYMin meet' // You can adjust this as needed
      width='510'
      height='429'
      viewBox='0 0 510 429'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className=' absolute left-[-1px] bottom-[-7px] z-30'
      style={{ height: '429px', width: '510px' }}
    >
      <path
        d='M509.242 383.594C509.242 408.17 489.319 428.094 464.742 428.094L45.0002 428.094C20.4236 428.094 0.500246 408.17 0.500248 383.594L0.500277 56.8249C69.725 31.762 156.443 5.16717 229.042 21.9179C241.247 24.734 254.164 23.9566 265.577 18.7239C287.278 8.77485 305.173 3.35631 321.849 1.38109C338.522 -0.593673 354.003 0.870378 370.882 4.71801C387.511 8.50841 405.48 14.6078 427.286 22.0094L428.317 22.3595C450.499 29.8882 476.625 38.7255 509.242 47.8095L509.242 383.594Z'
        fill='#9EC2D9'
        stroke='white'
      />
    </svg>
  );
};

export default Layer1;
